import cx from 'classnames';
import React, { useState } from 'react';
import { useDrag } from 'react-use-gesture';

import { SimpleCallback } from '../../../typings';

// @ts-ignore
import styles from './split-view__resizer.module.scss';

interface Props {
    onResizeStart: SimpleCallback;
    onResize: (movement: number) => void;
    onResizeEnd: (movement: number) => void;
    direction: 'row' | 'column';
    extendedActiveArea: boolean;
}

const directionToDimension = {
    row: 0, // x
    column: 1, // y
} as const;

const SplitViewResizer = (props: Props) => {
    const [isDragging, setIsDragging] = useState(false);
    const { extendedActiveArea } = props;

    const bind = useDrag((drag) => {
        setIsDragging(drag.dragging);

        if (drag.first) {
            props.onResizeStart();
        } else if (drag.last) {
            props.onResizeEnd(drag.movement[directionToDimension[props.direction]]);
        } else {
            props.onResize(drag.movement[directionToDimension[props.direction]]);
        }
    });

    return (
        <div
            {...bind()}
            className={cx(styles.resizer, styles[`resizer_direction_${props.direction}`], {
                [styles.resizer_dragging]: isDragging,
            })}
        >
            {extendedActiveArea && <div className={cx(styles.active_area, styles[`active_area_${props.direction}`])} />}
        </div>
    );
};

export default SplitViewResizer;
